import { FC } from 'react';

import { formatPrice } from '@shared/utils/formatPrice';

import { GiftDeliveryFeePreviewState } from '../hooks/useGiftDeliveryFeePreview';
import { isFreeBaseFeeApplied } from '../utils/giftDeliveryFeePreview.util';

interface IProps {
  deliveryFee: GiftDeliveryFeePreviewState;
}

/**
 * 결제 금액 블록의 "배송비" 줄 — 권역 배송비 대상 주문일 때만 렌더.
 * 배송 가능: 금액(0원은 "무료"), 지역 추가배송비 부연. 배송 불가/주소 불완전: 붉게 표시.
 */
export const GiftDeliveryFeeSummaryRow: FC<IProps> = ({ deliveryFee }) => {
  const { preview, loading } = deliveryFee;
  if (!preview || !preview.applicable) return null;

  if (!preview.deliverable) {
    return (
      <div className="flex justify-between">
        <span className="text-gray-500">배송비</span>
        <span className="text-xs font-bold text-red-500">
          {preview.reason === 'ADDRESS_INCOMPLETE'
            ? '주소 재검색 필요'
            : '배송 불가 지역'}
        </span>
      </div>
    );
  }

  const freeApplied = isFreeBaseFeeApplied(preview);

  return (
    <div className="flex justify-between">
      <span className="text-gray-500">
        배송비
        {preview.extraFee > 0 && (
          <span className="ml-1 text-[11px] text-orange-600">지역 추가배송비 포함</span>
        )}
        {freeApplied && preview.rule && (
          <span className="ml-1 text-[11px] text-green-600">
            {formatPrice(preview.rule.freeOverAmount)}원 이상 무료
          </span>
        )}
      </span>
      <span className={loading ? 'text-gray-400' : ''}>
        {preview.total === 0 ? '무료' : `${formatPrice(preview.total)}원`}
      </span>
    </div>
  );
};
